// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Recommendation = t.struct({
        connectedMachine: t.Boolean,
        distanceFromCogLocation: t.Number,
        estimatedHours: t.Number,
		id: t.String,
        lastSeenAtResposibleAccount: t.Number,
        lastSeenInAor: t.Number,
        lastSeenInCog: t.Number,
        reason: t.String,
        reasonEventNumber: t.String,
        recommendation: t.String,
        recommendationAccountComments: t.maybe(t.String),
        recommendationDate: t.Number,
        responsibleAccountComments:t.maybe(t.String),
        workOrderNumber: t.maybe(t.String)
}, {
    name: 'Recommendation',
    strict: true
});

export const getDefaultState = () => new Recommendation({
    connectedMachine: false,
    distanceFromCogLocation: 0,
    estimatedHours: 0,
	id: '',
    lastSeenAtResposibleAccount: 0,
    lastSeenInAor: 0,
    lastSeenInCog: 0,
    reason: '',
    reasonEventNumber: '',
    recommendation: '',
    recommendationDate: 0,
    workOrderNumber: ''
});

export default Recommendation;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/recommendation.js